import {
  Box,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { formatExecutionDate } from "../../../../../../components/Utils/dataFormater";
import { ErrorUnexpected } from "../../../../../../const/Messages";
import * as ArticleService from "../../../../../../service/DocumentArticleService";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export function ReviewModal({ open, handleClose, id }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (open) {
      ArticleService.getAllReviewById(id)
        .then((data) => {
          setData(data);
        })
        .catch(() => {
          toast.error(ErrorUnexpected);
        });
    }
  }, [id, open]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Typography
          id="review-modal-title"
          variant="h6"
          component="h2"
          gutterBottom
        >
          Revisions
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Author</TableCell>
                <TableCell>Created At</TableCell>
                <TableCell>Updated At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((revision, index) => (
                <TableRow key={index}>
                  <TableCell>{revision.user}</TableCell>
                  <TableCell>
                    {formatExecutionDate(revision.createdAt)}
                  </TableCell>
                  <TableCell>
                    {formatExecutionDate(revision.updatedAt)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
}
